import { createAction } from 'redux-actions';
import types from './types';

export const setItemsSearchHistory = createAction(types.SET_ITEMS_SEARCH_HISTORY);
export const removeItemSearchTerm = createAction(types.REMOVE_ITEM_SEARCH_TERM);

export const setWishesSearchHistory = createAction(types.SET_WISHES_SEARCH_HISTORY);
export const removeWishSearchTerm = createAction(types.REMOVE_WISH_SEARCH_TERM);
